import {
  LOAD_RECIPES_SUCCESS,
  CREATE_RECIPE_SUCCESS,
  UPDATE_RECIPE_SUCCESS,
  DELETE_RECIPE_OPTIMISTIC,
  DELETE_RECIPE_INGREDIENT_OPTIMISTIC,
  DELETE_RECIPE_STEP_OPTIMISTIC,
  UPDATE_RECIPE_ADMIN_OPTIMISTIC,
} from "./actionTypes";
import * as recipeApi from "../../api/recipeApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadRecipesSuccess(recipes) {
  return { type: LOAD_RECIPES_SUCCESS, recipes };
}

export function createRecipeSuccess(recipe) {
  return { type: CREATE_RECIPE_SUCCESS, recipe };
}

export function updateRecipeSuccess(recipe) {
  return { type: UPDATE_RECIPE_SUCCESS, recipe };
}

export function deleteRecipeOptimistic(recipe) {
  return { type: DELETE_RECIPE_OPTIMISTIC, recipe };
}

export function deleteRecipeIngredientOptimistic(recipe, ingredient) {
  return {
    type: DELETE_RECIPE_INGREDIENT_OPTIMISTIC,
    payload: { recipe, ingredient },
  };
}

export function deleteRecipeStepOptimistic(recipe, step) {
  return {
    type: DELETE_RECIPE_STEP_OPTIMISTIC,
    payload: { recipe, step },
  };
}

export function updateRecipeAdminOptimistic(recipeId, userId, userEmail) {
  return {
    type: UPDATE_RECIPE_ADMIN_OPTIMISTIC,
    payload: { recipeId, userId, userEmail },
  };
}

export function fetchRecipesByKeyword(keyword) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return recipeApi
      .getRecipesByKeyword(keyword)
      .then((recipes) => {
        dispatch(loadRecipesSuccess(recipes.data));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function deleteRecipe({ recipe, token }) {
  return function (dispatch) {
    dispatch(deleteRecipeOptimistic(recipe));
    return recipeApi.deleteRecipe({ recipe });
  };
}

export function deleteRecipeIngredient(recipe, ingredient) {
  return function (dispatch) {
    dispatch(deleteRecipeIngredientOptimistic(recipe, ingredient));
    return recipeApi.deleteRecipeIngredient(recipe, ingredient);
  };
}

export function deleteStep(recipe, step) {
  return function (dispatch) {
    dispatch(deleteRecipeStepOptimistic(recipe, step));
    return recipeApi.deleteRecipeStep(recipe, step);
  };
}

export function updateRecipeAdmin({ recipeId, userId, userEmail }) {
  recipeApi.updateRecipeAdmin({ recipeId, userId, userEmail });
  return function (dispatch) {
    dispatch(updateRecipeAdminOptimistic(recipeId, userId, userEmail));
  };
}

export function saveRecipe({ recipe }) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return recipeApi
      .saveRecipe({ recipe })
      .then((savedRecipe) => {
        recipe._id
          ? dispatch(updateRecipeSuccess(savedRecipe.data))
          : dispatch(createRecipeSuccess(savedRecipe.data));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadRecipes() {
  return function (dispatch) {
    dispatch(beginApiCall());
    return recipeApi
      .getRecipes()
      .then((recipes) => {
        dispatch(loadRecipesSuccess(recipes));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadPublicRecipes() {
  return function (dispatch) {
    dispatch(beginApiCall());
    return recipeApi
      .getRecipes()
      .then((recipes) => {
        dispatch(loadRecipesSuccess(recipes.data));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadRecipeById(id) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return recipeApi
      .getRecipeById({ id })
      .then((recipes) => {
        if (!Array.isArray(recipes.data)) {
          return dispatch(loadRecipesSuccess([recipes.data]));
        }
        return dispatch(loadRecipesSuccess(recipes.data));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadUserRecipes() {
  return function (dispatch) {
    dispatch(beginApiCall());

    return recipeApi
      .getUserRecipes()
      .then((recipes) => {
        return dispatch(loadRecipesSuccess(recipes.data));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
